import { render, staticRenderFns } from "./tagManagement.vue?vue&type=template&id=1e82e120&"
import script from "./tagManagement.vue?vue&type=script&lang=js&"
export * from "./tagManagement.vue?vue&type=script&lang=js&"
import style0 from "./tagManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports